import { backfaceFixed } from "./backfaceFixed";
import { manageEventListeners } from "./manageEventListeners";
import { waitModalAnimation } from "./waitModalAnimation";

export const openModal = (modal) => {
  let isTransitioning = false;

  if (isTransitioning) return;

  // eslint-disable-next-line no-useless-assignment
  isTransitioning = true;
  modal.showModal();
  backfaceFixed(true);
  manageEventListeners(modal, true);

  requestAnimationFrame(async () => {
    modal.setAttribute("data-active", "true");
    await waitModalAnimation(modal);
    isTransitioning = false;
  });
};
